var firestoretable = require('./firestoretable')

const state = {
  uploadedCustomerAccountsCollectionName: 'customerAccountUploads',
  uploadFolderPath: 'customeraccountuploads/',
  uploadFileName: '',
  uploadProgress: '',
  showUploadingModal: false,
  showUploadingSuccessModal: false,
  showUploadingFailedModal: false,
  showImportingModal: false,
  showImportingSuccessModal: false,
  showImportingFailedModal: false,
  importFailedMessage: '',
  uploadFailedMessage: '',
  all: [],
  headers: ['fileName', 'uploadedDate', 'status'],
  rowsPerPage: 20,
  currentPage: 1,
  totalRows: 0,
  showLoadingAnimation: false,
  showLoadingError: false,
  showNoResult: false,
  loadingErrorMessage: '',
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
}

const mutations = {
  toggleUploadingModal: function (state, show) {
    state.showUploadingModal = show
  },
  toggleUploadingSuccessModal: function (state, show) {
    state.showUploadingSuccessModal = show
  },
  toggleUploadingFailedModal: function (state, show) {
    state.showUploadingFailedModal = show
  },
  setUploadFailedMessage: function (state, message) {
    state.uploadFailedMessage = message
  },
  toggleImportingModal: function (state, show) {
    state.showImportingModal = show
  },
  toggleImportingSuccessModal: function (state, show) {
    state.showImportingSuccessModal = show
  },
  toggleImportingFailedModal: function (state, show) {
    state.showImportingFailedModal = show
  },
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
  },
  selectTableRow: function (state, docId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info'
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  toggleDisabledPagination: function (state, show) {
    state.disabledPagination = show
  }
}

const getters = {
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const actions = {
  uploadFileToFirebaseStorage (context, payload) {
    if (!payload.file) {
      console.log('Nothing to upload')
      context.commit('setUploadFailedMessage', 'Please select an Excel file to upload.')
      context.commit('toggleUploadingFailedModal', true)
      return
    }

    let firebaseStorageRef = context.rootState.fbStorage.ref()
    context.commit('toggleUploadingModal', true)

    let uploadTask = firebaseStorageRef.child(context.state.uploadFolderPath + payload.file.name).put(payload.file)
    uploadTask.on('state_changed', function (snapshot) {
      context.state.uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
    }, function (error) {
      context.commit('toggleUploadingModal', false)
      context.commit('toggleUploadingFailedModal', true)
      console.error(error)
    }, function () {
      let objToAdd = {
        fileName: payload.file.name,
        uploadedDate: new Date(),
        status: 'NEW'
      }

      context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName)
        .add(objToAdd)
        .then(function () {
          context.commit('toggleUploadingModal', false)
          context.commit('toggleUploadingSuccessModal', true)
          context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
        }).catch(function (err) {
          console.error(err)
          context.commit('toggleUploadingModal', false)
          context.commit('toggleUploadingFailedModal', true)
        })
    })
  },
  showAllUploads (context, payload) {
    context.state.all = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)
    context.commit('toggleDisabledPagination', true)

    let queryParameters = {
      collectionName: context.state.uploadedCustomerAccountsCollectionName,
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'desc',
      orderByFlippedDirection: 'asc'
    }

    let docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters)
    firestoretable.queryCollection(docQuery, context, queryParameters, false)

    context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName)
      .get().then(function (querySnapshot) {
        context.commit('updateTotalRows', querySnapshot.docs.length)
      })
  },
  importFile (context, payload) {
    context.commit('toggleImportingModal', true)
    context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).where('status', '==', 'IMPORTING')
      .get().then(function (querySnapshot) {
        if (querySnapshot.size === 0) {
          let docRef = context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).doc(payload.docId)
          docRef.update({status: 'IMPORTING'}).then(function () {
            context.dispatch('executeImport', payload)
          }).catch(function (err) {
            console.error(err)
          })
        } else {
          context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
          context.commit('toggleImportingModal', false)
        }
      })
  },
  executeImport (context, payload) {
    let currentUser = context.rootState.firebase.auth().currentUser
    if (!currentUser) {
      context.commit('toggleImportingModal', false)
      context.state.importFailedMessage = 'Please login again before importing.'
      context.commit('toggleImportingFailedModal', true)
      return
    }

    currentUser.getIdToken(true).then(function (idToken) {
      let projectId = context.rootState.firebase.app().options.projectId
      let cloudFunctionImportUrl = 'https://asia-southeast1-' + projectId + '.cloudfunctions.net/importCustomerAccountsFromStorage'
      console.log('Customer account import function URL: ' + cloudFunctionImportUrl)
      var xmlHttp = new XMLHttpRequest()
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          context.commit('toggleImportingModal', false)
          if (xmlHttp.status === 200) {
            context.commit('toggleImportingSuccessModal', true)
            context.dispatch('updateFileStatus', {docId: payload.docId, status: 'IMPORTED'})
            console.log('Customer account import result: ' + xmlHttp.responseText)
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
          } else {
            context.state.importFailedMessage = xmlHttp.responseText
            context.dispatch('updateFileStatus', {docId: payload.docId, status: 'NEW'})
            context.commit('toggleImportingFailedModal', true)
            context.dispatch('showAllUploads', { orderBys: 'uploadedDate' })
          }
        }
      }
      xmlHttp.open('POST', cloudFunctionImportUrl, true)
      xmlHttp.setRequestHeader('Content-Type', 'application/json')
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + idToken)
      xmlHttp.send(JSON.stringify({
        filename: payload.filename,
        status: payload.status
      }))
    }).catch(function (err) {
      context.commit('toggleImportingModal', false)
      context.state.importFailedMessage = err.message
      context.commit('toggleImportingFailedModal', true)
    })
  },
  updateFileStatus (context, payload) {
    let docRef = context.rootState.firestoreDB.collection(context.state.uploadedCustomerAccountsCollectionName).doc(payload.docId)
    docRef.update({status: payload.status}).catch(function (err) {
      console.error(err)
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/customeraccountuploadstoremodule.js